import { get, put, post, del } from "../../data/api";

export async function getUserProfiles() {
    return await get('userprofile/all/0/500')
}

export async function getUserProfile(publicId) {
    return await get('userprofile/' + publicId)
}
export async function getRentalsHistory(id) {
    return await get('userprofile/' + id + '/rentals/')
}
export async function getTools(id) {
    return await get('userprofile/' + id + '/tools/')
}
export async function updateUser(params, publicId) {

    return await put(params, 'userprofile/' + publicId)
}
export async function resetPwd(params, publicId) {

    return await put(params, 'userprofile/' + publicId + '/resetpwd')
}
export async function linkUser(userPublicIdd) {
    return await post(null, 'userprofile/' + userPublicIdd + '/link')
}
export async function sendOnboardingStripeMail(userPublicId) {
    return await post(null, 'userprofile/' + userPublicId + '/send-stripe-onboarding')
}
export async function deleteAccount(userPublicId) {
    return await del('userprofile/' + userPublicId)
}

export async function logoutUser(userPublicId) {
    return await post(null, 'userprofile/' + userPublicId + '/logout')
}

export async function addUserModule(userId, moduleType) {
    return await post({ moduleType }, `userprofile/${userId}/modules`)
}

export async function removeUserModule(userId, moduleType) {
    return await del(`userprofile/${userId}/modules/${encodeURIComponent(moduleType)}`)
}
